// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewTabs-TabSkeleton_cls1__w60Xd","cls2":"PaymentViewTabs-TabSkeleton_cls2__l00Nl PaymentViewTabs-TabSkeleton_cls1__w60Xd"};